module.exports = __webpack_public_path__ + "img/shenlan.7b4f59ab.png";